// extracted by mini-css-extract-plugin
module.exports = {"root":"LastenAreenaInfo_root__ftH1F"};